import {apiInstance} from '../api';

const route = '/builder';

export class ApiMotivationService {
  static async fetchMotivations() {
    return apiInstance.get(route);
  }

  static async createMotivation(newMotivation) {
    return apiInstance.post('/builder', newMotivation);
  }

  static async deleteMotivation(motivationId) {
    return apiInstance.delete(`${route}/${motivationId}`);
  }

  static async changeMotivation(motivationId, updateMotivation) {
    return apiInstance.put(`${route}/${motivationId}`, updateMotivation);
  }

}
